import { Component, OnInit,Input } from '@angular/core';

  @Component({
    selector: 'top-nav',
    templateUrl: './topnav.component.html',
    styleUrls: ['./topnav.component.scss']
  })
  export class TopnavComponent implements OnInit {
  
    constructor() { }
    
    @Input() locale:string;
    ngOnInit() {
    }
  
  }
  